export default __webpack_public_path__ + "static/media/tcpdump.b32d38e9.svg";